import PageContent from './components/PageContent'

const TodaysDeadLines = () => (
  <PageContent />
)

export default TodaysDeadLines
